module.exports = __webpack_public_path__ + "img/img3.1731d453.png";